export default __webpack_public_path__ + "locales/si/Webhooks.json?hash=3c7ec5a8a7acf3da18c97a50ecbc8d0c";